import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static values = {
    adminLoginUrl: String,
    posSetupUrl: String
  };

  connect () {
    window.addEventListener('scanning', this.scan.bind(this));
  }

  disconnect() {
    window.removeEventListener('scanning', this.scan);
  }

  scan(e) {
    var value = e.value

    if (value.startsWith("pos_setup") || value.startsWith("pos-setup")) {
      var stationIdentifier = value.split('--')[1]
      var setupUrl = this.posSetupUrlValue.replace('__REPLACE__', stationIdentifier)
      Turbo.visit(setupUrl, { action: 'replace' });
    } else if (value.startsWith("account-access-id")) {
      var accounAccessId = value.substring(17)
      var loginUrl = this.adminLoginUrlValue.replace('__REPLACE__', accounAccessId)
      Turbo.visit(loginUrl, { action: 'replace' });
    } else {
      var evt = event || window.event;
      var form = document.getElementById('addItemForm');
      document.getElementById('sku').value = e.value;

      window.Rails.fire(form, 'submit')
    }
  }
}
